import { RouteObject } from "react-router-dom";

import { AuthorizedRoute } from "src/authentication/AuthorizedRoute.tsx";
import { Scope, ScopeResource } from "src/authentication/PermissionsProvider";
import ErrorBoundary from "src/components/Errors/ErrorBoundary.tsx";
import { useT } from "src/internationalization";
import RulesPage from "src/pages/Rules/RulesPage.tsx";
import RulesTab from "src/pages/Rules/RulesTab.tsx";

export const useRulesRoutes = (): RouteObject[] => {
  const t = useT();

  return [
    {
      path: "rules",
      element: (
        <AuthorizedRoute
          requiredPermissions={[{ resource: ScopeResource.RULE, scopes: [Scope.VIEW] }]}
          pageTitle={t("rules.title")}
        >
          <RulesPage />
        </AuthorizedRoute>
      ),
      ErrorBoundary: ErrorBoundary,
      children: [
        {
          path: ":code",
          Component: RulesTab,
        },
      ],
    },
  ];
};
